import { render, staticRenderFns } from "./lsdds.vue?vue&type=template&id=86bc9634&scoped=true"
import script from "./lsdds.vue?vue&type=script&lang=js"
export * from "./lsdds.vue?vue&type=script&lang=js"
import style0 from "./lsdds.vue?vue&type=style&index=0&id=86bc9634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bc9634",
  null
  
)

export default component.exports